import { render } from "./vendors.vue?vue&type=template&id=55d914ee&scoped=true&ts=true"
import script from "./vendors.vue?vue&type=script&lang=ts"
export * from "./vendors.vue?vue&type=script&lang=ts"

import "./vendors.vue?vue&type=style&index=0&id=55d914ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d914ee"]])

export default __exports__